import React, { useState } from 'react';
import { IParentCheckboxGroup } from '../../../models/parent-checkbox-group/IParentCheckboxGroup';
// import CheckboxTree, { OnCheckNode } from "react-checkbox-tree";
// import "react-checkbox-tree/lib/react-checkbox-tree.css";
import '../../../styles/checkbox-group/checkbox-group.scss';
// import styles from './checkbox-tree.module.scss';

type Props = {
  filterNodes: IParentCheckboxGroup;
  checkedNodes?: Array<string>;
  expandedNodes?: Array<string>;
  onChangeCheckbox?: (currentCheckedNode: any) => void;
};

/**
 * For more information on params / props, check this:
 * \node_modules\react-checkbox-tree\src\index.d.ts
 */
export default function ParentCheckboxGroup({
  filterNodes,
  checkedNodes,
  expandedNodes,
  onChangeCheckbox,
}: Props) {
  const [checked, setChecked] = useState(checkedNodes); // <-- Array<string> to pre-check parent/childs
  const [expanded, setExpanded] = useState(expandedNodes); // <-- Array<string> to initially expand parent/child

  function onCheck(checked: Array<string>, node: any) {
    if (onChangeCheckbox) {
      // console.log("checked: ", checked); <-- selected node value
      // console.log("node: ", node); <-- selected node object
      setChecked(checked);
      onChangeCheckbox(node); // <-- onChangeCheckbox(<pass values as required>);
    }
  }

  function onExpand(expanded: Array<string>) {
    setExpanded(expanded);
  }

  return (
    <>
      {/*Commenting it out as this package blocks shared checkbox implementation in BrowseWeb*/}
      {/*It will be replaced in future tickets*/}

      {/*<CheckboxTree*/}
      {/*	checked={checked}*/}
      {/*	expanded={expanded}*/}
      {/*	iconsClass="fa5"*/}
      {/*	nodes={filterNodes.options}*/}
      {/*	onCheck={onCheck}*/}
      {/*	onExpand={onExpand}*/}
      {/*/>*/}
    </>
  );
}
